// extracted by mini-css-extract-plugin
export var actions = "_mb-g";
export var benefitCard = "_mb-b";
export var benefitIcon = "_mb-d";
export var benefitLabel = "_mb-f";
export var benefits = "_mb-a";
export var benefitsSection = "_mb-8";
export var bodyText = "_mb-7";
export var closeButton = "_mb-2";
export var content = "_mb-3";
export var eyebrow = "_mb-4";
export var heading = "_mb-5";
export var image = "_mb-i";
export var imagePanel = "_mb-h";
export var modal = "_mb-0";
export var offerCard = "_mb-c";
export var offerIcon = "_mb-e";
export var sectionLabel = "_mb-9";
export var shell = "_mb-1";
export var title = "_mb-6";